module.exports = __webpack_public_path__ + "static/media/image (36).7ad231db.jpg";